import { render } from "./RecordingsView.vue?vue&type=template&id=3ee44f7e&ts=true"
import script from "./RecordingsView.vue?vue&type=script&lang=ts"
export * from "./RecordingsView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lasseborgen/Documents/Makeable/tuk-dashboard-backend/upload-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__